import { render } from "./DoughnutChartScoreHalf.vue?vue&type=template&id=7a12a26d&scoped=true"
import script from "./DoughnutChartScoreHalf.vue?vue&type=script&lang=js"
export * from "./DoughnutChartScoreHalf.vue?vue&type=script&lang=js"

import "./DoughnutChartScoreHalf.vue?vue&type=style&index=0&id=7a12a26d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a12a26d"]])

export default __exports__